require('./bootstrap');


window.Vue = require('vue').default;

import Vue from 'vue';
import VueRouter from 'vue-router';

import Home from './components/Home.vue';

import AdminAreas from './components/AdminAreas.vue';
import AdminDistrictManagement from './components/AdminDistrictManagement.vue';
import AdminStandardEdit from './components/AdminStandardEdit.vue';
import AdminStandardExport from './components/AdminStandardExport.vue';
import AdminStandardImport from './components/AdminStandardImport.vue';
import AdminStudentUpload from './components/AdminStudentUpload.vue';
import AdminStudentUpdate from './components/AdminStudentUpdate.vue';
import AdminUserManage from './components/AdminUserManage.vue';
import AdminDistUsers from './components/AdminDistUsers.vue';
import AdminStudentReport from './components/AdminStudentReport.vue';

import Worksheet from './components/Worksheet.vue';
import AuditLog from './components/AuditLog.vue';
import ClassManagement from './components/ClassManagement.vue';



Vue.use(VueRouter);

Vue.component('App', require('./components/App.vue').default);

/**
 * These should all be /admin/xxx
 */
const routes = [
    { path: '/', component: Home },
    { path: '/classes/:data?', component: ClassManagement, props: true },
    { 
        path: '/worksheet',
        name: 'worksheet',
        component: Worksheet,
        props: true
    },
    
    // Global Admin Pages
    { path: '/admin/districts', component: AdminDistrictManagement },
    { path: '/admin/users', component: AdminUserManage },
    { path: '/admin/audit', component: AuditLog },
    
    // Content Admin Pages
    { path: '/admin/standards/edit', component: AdminStandardEdit },
    { path: '/admin/standards/import', component: AdminStandardImport },
    { path: '/admin/standards/export', component: AdminStandardExport },
    // => CREATE STD GOES HERE
    { path: '/admin/areas', component: AdminAreas },
    
    // District Admin Pages
    { path: '/admin/student/update', component: AdminStudentUpdate },
    { path: '/admin/student/upload', component: AdminStudentUpload },
    { path: '/admin/student/report', component: AdminStudentReport },
    { path: '/admin/dist-users', component: AdminDistUsers },
];

const router = new VueRouter({
    routes
});

// const app = new Vue({
//     router,
//     el: '#app',
// });

const app = new Vue({
    router,
}).$mount('#app');